// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 483 ? "15790d33" : chunkId) + "." + {"7":"a558bfb79268ab20","94":"33f904697945b7ae","139":"0a2349724ce64cd4","483":"651f9f47f996bec8"}[chunkId] + ".js";
};